import type { SidePanel } from '../types';

export const AcceptAutoApp: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./AcceptAutoApp.vue')),
};
